import { FormattedMessage as FM } from "react-intl";

import { PencilSquareIcon, TrashIcon } from "components/Icons";
import ListItemTags from "./ListItemTags";
import ListItemVisual from "./ListItemVisual";
import { STYLE_ACTION_BUTTON } from "../constants";

const STYLE_CARD_BUTTON = `${STYLE_ACTION_BUTTON} flex min-h-11 items-center gap-1.5 disabled:opacity-50`;

function ListItemCard({ config, item, locked, onEdit, onAskDelete, children }) {
  const detail = config.detailField && item[config.detailField];
  return (
    <div className="rounded-md border border-neutral-200 bg-white p-3">
      <div className="flex items-start gap-3">
        <ListItemVisual config={config} item={item} />
        <div className="min-w-0 flex-1">
          <p className="break-words text-sm font-medium text-neutral-800">
            {item[config.titleField] || <FM id="melhous.dash.list.untitled" />}
          </p>
          {detail && (
            <p className="mt-0.5 line-clamp-2 text-xs text-neutral-500">
              {detail}
            </p>
          )}
          <ListItemTags config={config} item={item} />
        </div>
      </div>
      <div className="mt-2 flex justify-end gap-2">
        <button
          type="button"
          disabled={locked}
          onClick={() => onEdit(item)}
          className={STYLE_CARD_BUTTON}
        >
          <PencilSquareIcon width={16} className="fill-current" />
          <FM id="melhous.dash.list.edit" />
        </button>
        <button
          type="button"
          disabled={locked}
          onClick={() => onAskDelete(item.id)}
          className={STYLE_CARD_BUTTON}
        >
          <TrashIcon width={16} className="fill-current" />
          <FM id="melhous.dash.list.delete" />
        </button>
      </div>
      {children}
    </div>
  );
}

export default ListItemCard;
